import React, { lazy } from 'react';
import { RouteObject } from 'react-router-dom';
import LanguageWrapper from '../components/feature/LanguageWrapper';

const HomePage = lazy(() => import('../pages/home/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const SupportPage = lazy(() => import('../pages/support/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const CookiePolicyPage = lazy(() => import('../pages/cookie-policy/page'));
const PrivacyPolicyPage = lazy(() => import('../pages/privacy-policy/page'));
const ProductsPage = lazy(() => import('../pages/products/components/page'));
const LaptopsDesktopsPage = lazy(() => import('../pages/products/laptops-desktops/page'));
const WorkstationsPage = lazy(() => import('../pages/products/workstations/page'));
const ServersStoragePage = lazy(() => import('../pages/products/servers-storage/page'));
const NetworkingPage = lazy(() => import('../pages/products/networking/page'));
const RoutersSwitchesPage = lazy(() => import('../pages/products/routers-switches/page'));
const WirelessSolutionsPage = lazy(() => import('../pages/products/wireless-solutions/page'));
const SecurityAppliancesPage = lazy(() => import('../pages/products/security-appliances/page'));
const OperatingSystemsPage = lazy(() => import('../pages/operating-systems/page'));
const BusinessSoftwarePage = lazy(() => import('../pages/business-software/page'));
const AntivirusSecurityPage = lazy(() => import('../pages/antivirus-security/page'));
const BackupSolutionsPage = lazy(() => import('../pages/backup-solutions/page'));
const AdobeCreativeCloudPage = lazy(() => import('../pages/adobe-creative-cloud/page'));
const Microsoft365Page = lazy(() => import('../pages/microsoft-365/page'));
const IntegrationConfigurationPage = lazy(() => import('../pages/integration-configuration/page'));
const EnterpriseSoftwareImplementationPage = lazy(() => import('../pages/enterprise-software-implementation/page'));
const AIConsultingPage = lazy(() => import('../pages/ai-consulting/page'));
const MachineLearningPage = lazy(() => import('../pages/machine-learning/page'));
const CloudServicesPage = lazy(() => import('../pages/cloud-services/page'));
const ITConsultingPage = lazy(() => import('../pages/it-consulting/page'));
const ProjectManagementPage = lazy(() => import('../pages/project-management/page'));
const ManagedITServicesPage = lazy(() => import('../pages/managed-it-services/page'));
const DigitalTransformationPage = lazy(() => import('../pages/digital-transformation/page'));
const InfrastructureOptimizationPage = lazy(() => import('../pages/infrastructure-optimization/page'));
const CyberSecurityPage = lazy(() => import('../pages/cyber-security/page'));
const AIAutomationIntegrationPage = lazy(() => import('../pages/ai-automation-integration/page'));
const ConversationalAIPage = lazy(() => import('../pages/conversational-ai/page'));
const ComputerVisionPage = lazy(() => import('../pages/computer-vision/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));
const TermsOfServicePage = lazy(() => import('../pages/terms-of-service/page'));
const CareersPage = lazy(() => import('../pages/careers/page'));

const HomePageNL = lazy(() => import('../pages/home/page.nl'));
const ITConsultingPageNL = lazy(() => import('../pages/it-consulting/page.nl'));
const ManagedITServicesPageNL = lazy(() => import('../pages/managed-it-services/page.nl'));
const InfrastructureOptimizationPageNL = lazy(() => import('../pages/infrastructure-optimization/page.nl'));
const CyberSecurityPageNL = lazy(() => import('../pages/cyber-security/page.nl'));
const DigitalTransformationPageNL = lazy(() => import('../pages/digital-transformation/page.nl'));
const EnterpriseSoftwareImplementationPageNL = lazy(() => import('../pages/enterprise-software-implementation/page.nl'));
const IntegrationConfigurationPageNL = lazy(() => import('../pages/integration-configuration/page.nl'));
const ProjectManagementPageNL = lazy(() => import('../pages/project-management/page.nl'));
const AIConsultingPageNL = lazy(() => import('../pages/ai-consulting/page.nl'));
const MachineLearningPageNL = lazy(() => import('../pages/machine-learning/page.nl'));
const AIAutomationIntegrationPageNL = lazy(() => import('../pages/ai-automation-integration/page.nl'));
const ComputerVisionPageNL = lazy(() => import('../pages/computer-vision/page.nl'));
const ConversationalAIPageNL = lazy(() => import('../pages/conversational-ai/page.nl'));
const TermsOfServicePageNL = lazy(() => import('../pages/terms-of-service/page.nl'));
const CareersPageNL = lazy(() => import('../pages/careers/page.nl'));
const CookiePolicyPageNL = lazy(() => import('../pages/cookie-policy/page.nl'));
const ContactPageNL = lazy(() => import('../pages/contact/page.nl'));

/* -------------------------------------------------------------------------- */
/*                               ENGLISH ROUTES                               */
/* -------------------------------------------------------------------------- */
const enRoutes: RouteObject[] = [
  { path: '/', element: <HomePage /> },
  { path: '/about', element: <AboutPage /> },
  { path: '/support', element: <SupportPage /> },
  { path: '/contact', element: <ContactPage /> },
  { path: '/cookie-policy', element: <CookiePolicyPage /> },
  { path: '/privacy-policy', element: <PrivacyPolicyPage /> },
  { path: '/products/components', element: <ProductsPage /> },
  { path: '/products/laptops-desktops', element: <LaptopsDesktopsPage /> },
  { path: '/products/servers-storage', element: <ServersStoragePage /> },
  { path: '/products/networking', element: <NetworkingPage /> },
  { path: '/products/routers-switches', element: <RoutersSwitchesPage /> },
  { path: '/products/wireless-solutions', element: <WirelessSolutionsPage /> },
  { path: '/products/security-appliances', element: <SecurityAppliancesPage /> },
  { path: '/products/workstations', element: <WorkstationsPage /> },
  { path: '/microsoft-365', element: <Microsoft365Page /> },
  { path: '/adobe-creative-cloud', element: <AdobeCreativeCloudPage /> },
  { path: '/operating-systems', element: <OperatingSystemsPage /> },
  { path: '/antivirus-security', element: <AntivirusSecurityPage /> },
  { path: '/backup-solutions', element: <BackupSolutionsPage /> },
  { path: '/business-software', element: <BusinessSoftwarePage /> },
  { path: '/cloud-services', element: <CloudServicesPage /> },
  { path: '/it-consulting', element: <ITConsultingPage /> },
  { path: '/managed-it-services', element: <ManagedITServicesPage /> },
  { path: '/cyber-security', element: <CyberSecurityPage /> },
  { path: '/infrastructure-optimization', element: <InfrastructureOptimizationPage /> },
  { path: '/digital-transformation', element: <DigitalTransformationPage /> },
  { path: '/enterprise-software-implementation', element: <EnterpriseSoftwareImplementationPage /> },
  { path: '/integration-configuration', element: <IntegrationConfigurationPage /> },
  { path: '/project-management', element: <ProjectManagementPage /> },
  { path: '/ai-consulting', element: <AIConsultingPage /> },
  { path: '/machine-learning', element: <MachineLearningPage /> },
  { path: '/ai-automation-integration', element: <AIAutomationIntegrationPage /> },
  { path: '/computer-vision', element: <ComputerVisionPage /> },
  { path: '/conversational-ai', element: <ConversationalAIPage /> },
  { path: '/terms-of-service', element: <TermsOfServicePage /> },
  { path: '/careers', element: <CareersPage /> },
];

/* -------------------------------------------------------------------------- */
/*                                 DUTCH ROUTES                               */
/* -------------------------------------------------------------------------- */
// Prefix every English route with "/nl" and wrap the page with LanguageWrapper.
// The wildcard route is excluded because the NotFound page is language‑agnostic.
const nlRoutes: RouteObject[] = enRoutes
  .filter((r) => r.path !== '*')
  .map((route) => ({
    path: route.path === '/' ? '/nl' : `/nl${route.path}`,
    element:
      route.path === '/' ? (
        <LanguageWrapper lang="nl">
          <HomePageNL />
        </LanguageWrapper>
      ) : route.path === '/it-consulting' ? (
        <LanguageWrapper lang="nl">
          <ITConsultingPageNL />
        </LanguageWrapper>
      ) : route.path === '/managed-it-services' ? (
        <LanguageWrapper lang="nl">
          <ManagedITServicesPageNL />
        </LanguageWrapper>
      ) : route.path === '/infrastructure-optimization' ? (
        <LanguageWrapper lang="nl">
          <InfrastructureOptimizationPageNL />
        </LanguageWrapper>
      ) : route.path === '/cyber-security' ? (
        <LanguageWrapper lang="nl">
          <CyberSecurityPageNL />
        </LanguageWrapper>
      ) : route.path === '/digital-transformation' ? (
        <LanguageWrapper lang="nl">
          <DigitalTransformationPageNL />
        </LanguageWrapper>
      ) : route.path === '/enterprise-software-implementation' ? (
        <LanguageWrapper lang="nl">
          <EnterpriseSoftwareImplementationPageNL />
        </LanguageWrapper>
      ) : route.path === '/integration-configuration' ? (
        <LanguageWrapper lang="nl">
          <IntegrationConfigurationPageNL />
        </LanguageWrapper>
      ) : route.path === '/project-management' ? (
        <LanguageWrapper lang="nl">
          <ProjectManagementPageNL />
        </LanguageWrapper>
      ) : route.path === '/ai-consulting' ? (
        <LanguageWrapper lang="nl">
          <AIConsultingPageNL />
        </LanguageWrapper>
      ) : route.path === '/machine-learning' ? (
        <LanguageWrapper lang="nl">
          <MachineLearningPageNL />
        </LanguageWrapper>
      ) : route.path === '/ai-automation-integration' ? (
        <LanguageWrapper lang="nl">
          <AIAutomationIntegrationPageNL />
        </LanguageWrapper>
      ) : route.path === '/computer-vision' ? (
        <LanguageWrapper lang="nl">
          <ComputerVisionPageNL />
        </LanguageWrapper>
      ) : route.path === '/conversational-ai' ? (
        <LanguageWrapper lang="nl">
          <ConversationalAIPageNL />
        </LanguageWrapper>
      ) : route.path === '/terms-of-service' ? (
        <LanguageWrapper lang="nl">
          <TermsOfServicePageNL />
        </LanguageWrapper>
      ) : route.path === '/careers' ? (
        <LanguageWrapper lang="nl">
          <CareersPageNL />
        </LanguageWrapper>
      ) : route.path === '/cookie-policy' ? (
        <LanguageWrapper lang="nl">
          <CookiePolicyPageNL />
        </LanguageWrapper>
      ) : route.path === '/contact' ? (
        <LanguageWrapper lang="nl">
          <ContactPageNL />
        </LanguageWrapper>
      ) : (
        <LanguageWrapper lang="nl">
          {route.element}
        </LanguageWrapper>
      ),
  }));

/* -------------------------------------------------------------------------- */
/*                                   EXPORT                                    */
/* -------------------------------------------------------------------------- */
const routes: RouteObject[] = [
  ...enRoutes,
  ...nlRoutes,
  { path: '*', element: <NotFoundPage /> },
];

export default routes;
